import { ExternalChartComponentProps } from '../../data-viz-containers/common/types';
import {
  OverTimeUnsegmentedViz,
  OverTimeUnsegmentedVizProps,
} from '../../data-viz-containers/over-time-unsegmented/OverTimeUnsegmentedViz';
import { OverTimeUnsegmentedVizViews } from '../../data-viz-containers/over-time-unsegmented/types';
import {
  StoryboardComponentIds,
  StoryboardComponentSettings,
} from '../common/types';
import { OverTimeUnsegmentedStoryboardComponentConfig } from './types';

const componentConfigToVizContainerProps = (
  componentConfig: OverTimeUnsegmentedStoryboardComponentConfig,
  externalProps: ExternalChartComponentProps,
  persistenceKey: string
) => {
  return {
    dataConfig: componentConfig.dataConfig,
    selectedView: componentConfig.selectedView,
    externalProps: externalProps,
    persistenceKey: persistenceKey,
  };
};

export const overTimeUnsegmentedStoryboardComponentSettings: StoryboardComponentSettings<
  OverTimeUnsegmentedStoryboardComponentConfig,
  OverTimeUnsegmentedVizProps
> = {
  componentId: StoryboardComponentIds.OVERTIME_UNSEGMENTED,
  componentConfigToVizContainerProps: componentConfigToVizContainerProps,
  VizContainerComponent: OverTimeUnsegmentedViz,
  validateConfig: (componentConfig) => {
    const { selectedView, dataConfig } = componentConfig;
    const { benchmarkConfig } = dataConfig;
    if (
      benchmarkConfig &&
      selectedView === OverTimeUnsegmentedVizViews.BAR_CHART
    ) {
      return {
        isValid: false,
        error: new Error(
          'Bar chart view for overtime unsegmented queries does not support benchmark'
        ),
      };
    }
    return {
      isValid: true,
      error: null,
    };
  },
};
